var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.332 10 11.522 6.528c4.247 2.407 6.042 2.407 10.29 0L36.665 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.358 22.46c.11 5.109.164 7.663 2.049 9.556s4.509 1.958 9.756 2.09c3.235.081 6.437.081 9.671 0 5.247-.132 7.871-.198 9.756-2.09 1.886-1.893 1.94-4.447 2.049-9.556.035-1.643.035-3.276 0-4.92-.109-5.108-.163-7.663-2.049-9.555-1.885-1.893-4.509-1.959-9.756-2.09a192 192 0 0 0-9.67 0c-5.248.131-7.872.197-9.757 2.09s-1.94 4.447-2.049 9.556a115 115 0 0 0 0 4.918Z"
  })));
};
export default SvgMail;